import { useIp } from '@/components/ip-provider';
import { useEffect } from 'react';

export const useGaViewItem = ({ product }: { product: any }) => {
  const { currentIp } = useIp();

  useEffect(() => {
    if (product) {
      try {
        const productPrice = product?.price_range?.maximum_price;

        fetch('/api/pinterest-page-visit', {
          method: 'POST',
          body: JSON.stringify({
            product: product,
            productPrice,
            ip: currentIp,
          }),
        });
      } catch (err) {
        console.error('Pinterest conversion error:', err);
      }

      try {
        const productPrice = product?.price_range?.maximum_price?.final_price;

        window.dataLayer &&
          window.dataLayer.push({
            ecommerce: null,
          });
        window.dataLayer &&
          window.dataLayer.push({
            event: 'view_item',
            ecommerce: {
              currency: productPrice?.currency,
              value: productPrice?.value,
              items: [
                {
                  item_id: product?.sku,
                  item_name: product?.name,
                  price: productPrice?.value,
                  quantity: 1,
                },
              ],
            },
          });
      } catch (err) {
        console.error(err);
      }
    }
  }, [product, currentIp]);
};
